<template>
	<div class="jurisdiction sub_panel">
		<section-title v-on:toggleExpansion="toggleExpansion" title="Jurisdiction" :is-expanded="is_expanded"></section-title>
		<el-collapse-transition>
			<div class="panel_detail" v-show="is_expanded">
				<el-form-item class="jurisdiction-form-item" prop="jurisdiction.name" :rules="validation.name">
					<el-radio-group class="flex-radio-group" size="small" v-model="name">
						<el-radio-button label="both"></el-radio-button>
						<el-radio-button label="charleston"></el-radio-button>
						<el-radio-button label="berkeley"></el-radio-button>
					</el-radio-group>
				</el-form-item>
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
import panel_mixin from './panel-mixin.js';
import sectionTitle from './Section-Title.vue';
import { mapFields } from 'vuex-map-fields';
export default{
	mixins: [panel_mixin],
	components: {
		sectionTitle
	},
	computed: {
		...mapFields('jurisdiction', ['name', 'is_expanded'])
	},
	data: function(){
		return {
			validation: {
				name: [
					{required: true, message: "Please select a jurisdiction."}
				]
			}
		}
	}
}
</script>

<style scoped>

.jurisdiction{
	margin-bottom:5px;
}

.flex-radio-group{
	display:flex;
	justify-content:center;
	text-transform:uppercase;
}

.jurisdiction >>> .el-radio-group{
	width:100%;
	font-family: 'News Cycle', sans-serif !important;
}

.jurisdiction .jurisdiction-form-item{
	margin-bottom:0 !important;
}

.jurisdiction >>> .el-radio-button{
	flex-grow: 1;
}

.jurisdiction >>> .is-active .el-radio-button__inner{
	color:white;
	background-color:#359DB4;
}

.jurisdiction >>> .el-radio-button__inner{
	padding:10px;
	width:100%;
	border-color: #359DB4;
	background-color: white;
	color:#359DB4;
	font-size:12px;
	transition:background-color .2s linear;
}

.jurisdiction >>> .el-radio-group .el-radio-button:hover .el-radio-button__inner{
	color:white;
	background-color:#359DB4;
}

</style>
